import React, { useCallback } from 'react'
import { cn } from '../../utils/lib/utils'
import PropTypes from 'prop-types'

/**
 * @typedef {Object} Option
 * @property {*} label
 * @property {*} value
 */

/**
 * @typedef {Object} MultiSelectProps
 * @property {*} options
 * @property {*} value
 * @property {*} onChange
 * @property {*} className?
 * @property {*} placeholder?
 */

const MultiSelect = React.forwardRef(({ 
  options = [], 
  value = [], 
  onChange, 
  className,
  ...props 
}, ref) => {
  const removeOption = useCallback((e, optionValue) => {
    e.stopPropagation()
    onChange(value.filter((v) => v !== optionValue))
  }, [onChange, value])

  return (
    <div 
      ref={ref}
      className={cn("flex flex-wrap gap-2 p-2 border rounded-md", className)}
      {...props}
    >
      {value.map((v) => (
        <div 
          key={v}
          className="flex items-center gap-1 px-2 py-1 bg-primary/10 rounded-md"
        >
          <span>{options.find(opt => opt.value === v)?.label || v}</span>
          <button
            type="button"
            onClick={(e) => removeOption(e, v)}
            className="text-sm hover:text-destructive"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
})

MultiSelect.displayName = 'MultiSelect'

export { MultiSelect }

MultiSelect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.any.isRequired,
      value: PropTypes.any.isRequired
    })
  ).isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string
}
